import $ from 'jquery';

export class ShowHide {
  public static get wireup(): string { return 'showhide'.asDataSelector(); }

  private defaults: IShowHideOptions = {
    selector: null,
    alternateText: null,
    shouldShow: false,
    context: $(<any>document)
  };
  private showText: string;
  private hideText: string;

  constructor(private $element: JQuery, private options: IShowHideOptions) {
    this.options = $.extend({}, this.defaults, this.options, this.$element.data());
    
    this.validate();
    if (typeof this.options.context === 'string')
      this.options.context = $(this.options.context);
    this.options.shouldShow = this.$element.hasClass('showhide-toggled');
    this.showText = this.options.shouldShow ? this.$element.text() : this.options.alternateText;
    this.hideText = this.options.shouldShow ? this.options.alternateText : this.$element.text();
  }

  public toggle(): void {
    this.toggleShouldShow();
    this.apply();
  }

  public apply($context?: JQuery): void {
    var $originalContext = this.options.context;
    try {
      if ($context) {
        this.options.context = $context;
      }
      this.setContentVisibility();
      this.setText();
      this.setClass();
    }
    finally {
      this.options.context = $originalContext;
    }
  }

  private validate() {
    if (this.$element.length == 0)
      throw new Error("$element is required");
    if (this.options.selector == null)
      throw new Error("selector is required");
  }

  private setContentVisibility() {
    var $elements = $(this.options.selector, this.options.context);
    if (this.options.shouldShow == true) {
      this.options.animation == 'slide' ? $elements.slideDown(200) : $elements.show();
    }
    else {
      this.options.animation == 'slide' ? $elements.slideUp(200) : $elements.hide();
    }
    $elements.trigger("visibilitychanged.pb");
  }

  private setText() {
    if (!this.options.alternateText)
      return;

    if (this.options.shouldShow) {
      this.$element.text(this.showText);
    }
    else {
      this.$element.text(this.hideText);
    }
  }

  private toggleShouldShow() {
    this.options.shouldShow = !this.options.shouldShow;
  }

  private setClass() {
    this.$element.toggleClass("showhide-toggled", this.options.shouldShow);
  }
}

export interface IShowHideOptions {
  selector: string;
  alternateText?: string;
  shouldShow?: boolean;
  context?: JQuery;
  animation?: string;
}

$(document).on('click.pb.showhide', '[data-showhide]', function (e) {
  var $target = $(e.target);
  var isLink = $target.is('a') && $target.attr('href') != null;
  var isRemote = $target.data('remote') || $target.parent().data('remote');
  var areWeTryingToGoSomewhere = isLink || isRemote;

  if (!areWeTryingToGoSomewhere) {
    e.preventDefault();
    $(this).showhide('toggle');
  }
});

// PLUGIN DEFINITION
// =========================
function Plugin(option, args) {
  return this.each(function () {
    var $this = $(this);
    var data = $this.data('pb.showhide');
    var options = typeof option == 'object' && option;

    if (!data) {
      data = new ShowHide($this, options);
      $this.data('pb.showhide', data);
    }
    if (typeof option == 'string')
      data[option](args);
  });
}

$.fn.showhide = Plugin;

declare global {
  interface JQuery {
    showhide: (option, args?) => any;
  }
}

export default ShowHide;